// // useApi.js
// import { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { getAuthToken } from './auth/authService';

// // Helper function to get a cookie by name
// const getCookie = (name) => {
//   const cookies = document.cookie.split('; ');
//   for (let cookie of cookies) {
//     const [key, value] = cookie.split('=');
//     if (key === name) {
//       return value;
//     }
//   }
//   return null;
// };

// const useApi = (url, method = 'GET', body = null, headers = {}, dependencies = []) => {
//   const navigate = useNavigate();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchData = useCallback(async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       // Check for access_token in cookies
//       // const accessToken = getCookie('access_token');
//       const accessToken = getAuthToken();
//       const authHeaders = accessToken
//         ? { ...headers, Authorization: `Bearer ${accessToken}` }
//         : headers;

//       const options = {
//         method,
//         url,
//         data: body,
//         headers: authHeaders,
//       };

//       const response = await axios(options);
//       if (response.statusText === 'OK' || response.status === 200) {
//         setData(response.data);
//       } else {
//         throw new Error('Error fetching data');
//       }
//     } catch (err) {
//       if(err?.status === 401) {
//         // Handle unauthorized access
//         console.error('Unauthorized access:', err);
//         // Optionally, redirect to login or show a message
//       } else if (err?.response?.status === 404) {
//         // Handle not found error
//         console.error('Data not found:', err);
//       } else if (err?.response?.status === 500) {
//         // Handle server error
//         console.error('Server error:', err);
//       } else {
//         // Handle other errors
//         console.error('Error fetching data:', err);
//       }
//       navigate('/')
//       setError(err);
//     } finally {
//       // console.log(('Error fetching finally'))
//       setLoading(false);
//     }
//   }, [url, method, body, headers]);

//   useEffect(() => {
//     fetchData();
//   }, dependencies);

//   return { data, loading, error };
// };

// export default useApi;

// useApi.js
import axiosInstance from './axiosInstance';
import { useState, useEffect, useCallback } from 'react';

const useApi = (url, method = 'GET', body = null, headers = {}, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const options = {
        method,
        url,
        data: body,
        headers, // Axios instance already sets auth header
      };

      const response = await axiosInstance(options);
      if (response.status === 200 || response.statusText === 'OK') {
        setData(response.data);
      } else {
        throw new Error('Error fetching data');
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [url, method, body, headers]);

  useEffect(() => {
    fetchData();
  }, dependencies);

  return { data, loading, error };
};

export default useApi;
